import { sr } from "./rng";

export function StarField({ seed = 777 }) {
  const stars = [];
  const rng = sr(seed);
  for (let i = 0; i < 120; i++) {
    const x = rng() * 100;
    const y = rng() * 100;
    const size = 1.5 + rng() * 1.5;
    const op = 0.3 + rng() * 0.4;
    stars.push(
      <div key={`s${i}`} style={{
        position: "absolute",
        left: `${x}%`, top: `${y}%`,
        width: size, height: size,
        borderRadius: "50%",
        background: `rgba(228, 222, 212, ${op})`,
        pointerEvents: "none",
      }} />
    );
  }
  for (let i = 0; i < 50; i++) {
    const x = rng() * 100;
    const y = rng() * 100;
    const size = 2.5 + rng() * 2;
    const op = 0.5 + rng() * 0.4;
    stars.push(
      <div key={`m${i}`} style={{
        position: "absolute",
        left: `${x}%`, top: `${y}%`,
        width: size, height: size,
        borderRadius: "50%",
        background: `rgba(228, 222, 212, ${op})`,
        boxShadow: `0 0 ${size + 2}px rgba(228, 222, 212, ${(op * 0.4).toFixed(2)})`,
        pointerEvents: "none",
      }} />
    );
  }
  for (let i = 0; i < 15; i++) {
    const x = rng() * 100;
    const y = rng() * 100;
    const size = 3 + rng() * 3;
    const op = 0.7 + rng() * 0.3;
    const hue = rng() > 0.6 ? "200, 220, 240" : rng() > 0.3 ? "228, 222, 212" : "220, 190, 150";
    stars.push(
      <div key={`b${i}`} style={{
        position: "absolute",
        left: `${x}%`, top: `${y}%`,
        width: size, height: size,
        borderRadius: "50%",
        background: `rgba(${hue}, ${op})`,
        boxShadow: `0 0 ${size * 2}px rgba(${hue}, ${(op * 0.5).toFixed(2)}), 0 0 ${size * 4}px rgba(${hue}, ${(op * 0.15).toFixed(2)})`,
        pointerEvents: "none",
      }} />
    );
  }
  return (
    <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 0, overflow: "hidden" }}>
      {stars}
    </div>
  );
}
